import { Button, useNotify, useRefresh } from "react-admin";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const SaveButtonSlot = ({ setIsSlotInfoEditing }) => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const {
    getValues,
    formState: { isDirty },
  } = useFormContext();
  const { id } = useParams();

  const notify = useNotify();
  const refresh = useRefresh();

  const handleSaveClick = async () => {
    const formDataToSave = getValues();
    const body = {
      roomId: formDataToSave.roomId,
      isOnline: formDataToSave.isOnline,
      googleCourseRefId: formDataToSave.googleCourseRefId,
      date: formDataToSave.date,
      startTime: formDataToSave.startTime,
      endTime: formDataToSave.endTime,
    };

    try {
      await dataProvider.customRequest(studentRequests.updateSessionExamSlot(id), body, "PUT");
      refresh();
      notify("Данните са запазени успешно!", { type: "success" });
      setIsSlotInfoEditing(false);
    } catch (e) {
      notifyError(e);
      handleConflictError(e);
    }
  };

  return (
    <>
      <Button
        label="Запази"
        onClick={handleSaveClick}
        disabled={!isDirty}
        startIcon={<SaveIcon />}
        variant="contained"
        size="medium"
      />
      <ConflictErrorDialog />
    </>
  );
};
export default SaveButtonSlot;
